export const FETCH_AUDITTRAILLIST_REQUEST = "FETCH_AUDITTRAILLIST_REQUEST";
export const FETCH_AUDITTRAILLIST_SUCCESS = "FETCH_AUDITTRAILLIST_SUCCESS";
export const FETCH_AUDITTRAILLIST_FAILURE = "FETCH_AUDITTRAILLIST_FAILURE";
